import { Modal } from "@/components/ui/modal";
import { Calendar } from "lucide-react";

interface BlogModalProps {
  isOpen: boolean;
  onClose: () => void;
  blog: {
    id: string;
    title: string;
    content: string;
    date?: string;
  } | null;
}

export function BlogModal({ isOpen, onClose, blog }: BlogModalProps) {
  if (!blog) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <div className="space-y-5 animate-[fadeInScale_0.25s_ease-out]">
        {/* Blog Date */}
        {blog.date && (
          <div className="flex items-center gap-2 text-sm text-emerald-400/90">
            <Calendar className="w-4 h-4" />
            <time>{blog.date}</time>
          </div>
        )}

        {/* Blog Title */}
        <h2 className="text-2xl sm:text-3xl font-bold text-emerald-100 leading-tight">
          {blog.title}
        </h2>

        {/* Blog Content */}
        <div className="rounded-xl bg-slate-800/40 border border-white/5 p-5 max-h-[60vh] overflow-y-auto">
          <div className="prose prose-invert prose-emerald max-w-none">
            <div 
              className="text-sm leading-relaxed text-slate-300 whitespace-pre-wrap"
              dangerouslySetInnerHTML={{ __html: blog.content }}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}
